export default "__VITE_ASSET__gwOWgstR__"